// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ty","contentWrapCtaDefault":"uy","disabled":"vy","contentWrapCtaWhite":"wy","promos":"xy","lazyPromo":"yy","mainContent":"zy","headingText":"Ay","copy":"By","subtext":"Cy"};